import Modal from './Modal'
export default Modal



// WEBPACK FOOTER //
// src/component/Modal/index.js